<form class="col-12 col-md-12" [formGroup]="providerForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="modal-body row shadow-sm p-3 mb-5 bg-white rounded box-form">

    <!-- Título -->
    <div class="col-12 pt-3">
      <p style="font-size: 18px; font-weight: 600; text-transform: uppercase; text-align:center;"
         [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">
       exclusivo proveedores de servicios turísticos
      </p>
    </div>

    <!-- YouAreType (oculto) -->
    <input type="hidden" formControlName="Youaretype">
    <input type="hidden" formControlName="client_id">

        <!-- Teléfono -->
    <div class="col-12 col-md-6 form-item pt-3">
      <div>
        <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Tipo proveedor</label>
        <div class="d-flex">
          <div style="width: 100%">
            <select class="form-control text-field"
              [ngClass]="{
                'is-invalid': providerForm.get('type_provider')?.touched && providerForm.get('type_provider')?.invalid,
                'is-valid': providerForm.get('type_provider')?.touched && providerForm.get('type_provider')?.valid
              }"
              formControlName="type_provider">
              <option value="" disabled>Seleccione tipo</option>
              <option value="'provider'">Prestador</option>
              <option value="'integrator'">Integrador</option>
              <!-- <option *ngFor="let country of countries" [value]="country.phone_code">
                {{country.country_name}} (+{{country.phone_code}})
              </option> -->
            </select>
          </div>
        </div>
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('type_provider')?.touched && providerForm.get('type_provider')?.invalid">
          Debe seleccionar un tipo de proveedor
        </span>
      </div>
    </div>

    <!-- Nombre -->
    <div class="col-12 col-md-6 form-item pt-3">
      <div>
        <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre proveedor</label>
        <input
              type="text"
              formControlName="Name"
              [ngClass]="{
                            'is-invalid': providerForm.get('Name')?.touched && providerForm.get('Name')?.invalid,
                            'is-valid': providerForm.get('Name')?.touched && providerForm.get('Name')?.valid
                        }"
              class="form-control text-field"
              (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              [maxLength]="50"
              minLength="2"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              (input)="sanitizeInput($event)"
              (keydown)="blockDangerousKeys($event)"
              required
          >
        <span class="booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Name')?.touched && providerForm.get('Name')?.invalid && !providerForm.get('Name')?.errors?.minlength">
          Por favor inserte un nombre
        </span>
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Name')?.errors?.minlength || providerForm.get('Name')?.errors?.maxlength">
          El nombre debe tener entre 2-50 carácteres
        </span>
      </div>
    </div>

    <!-- Email -->
    <div class="col-12 col-md-6 form-item pt-3">
      <div>
        <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Email</label>
        <input
                type="email"
                formControlName="Email"
                [ngClass]="{
                            'is-invalid': providerForm.get('Email')?.touched && providerForm.get('Email')?.invalid,
                            'is-valid': providerForm.get('Email')?.touched && providerForm.get('Email')?.valid
                          }"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockDangerousKeys($event)"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
        >
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Email')?.touched && providerForm.get('Email')?.invalid && !providerForm.get('Email')?.errors?.email">
          Por favor inserte un email
        </span>
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Email')?.errors?.email">
          Inserte un email valido
        </span>
      </div>
    </div>

    <!-- Dirección -->
    <div class="col-12 col-md-6 form-item pt-3">
      <div>
        <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Dirección</label>
        <input type="text"
                formControlName="Address"
                [ngClass]="{
                            'is-invalid': providerForm.get('Address')?.touched && providerForm.get('Address')?.invalid,
                            'is-valid': providerForm.get('Address')?.touched && providerForm.get('Address')?.valid
                          }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockDangerousKeys($event)"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                class="form-control text-field"
                required
        >
        <span class="booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Address')?.touched && providerForm.get('Address')?.invalid">
          Por favor inserte una dirección
        </span>
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('Address')?.errors?.minlength || providerForm.get('Address')?.errors?.maxlength">
          La dirección debe tener entre 5-100 carácteres
        </span>
      </div>
    </div>

    <!-- Teléfono -->
    <div class="col-12 col-md-6 form-item pt-3">
      <div>
        <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nro. telefónico</label>
        <div class="d-flex">
          <div style="width: 100%">
            <select class="form-control text-field"
              [ngClass]="{
                'is-invalid': providerForm.get('PhoneCode')?.touched && providerForm.get('PhoneCode')?.invalid,
                'is-valid': providerForm.get('PhoneCode')?.touched && providerForm.get('PhoneCode')?.valid
              }"
              formControlName="PhoneCode">
              <option value="" disabled>Seleccione código</option>
              <option *ngFor="let country of countries" [value]="country.phone_code">
                {{country.country_name}} (+{{country.phone_code}})
              </option>
            </select>
          </div>
          <div style="margin-left: 6px;">
            <input class="form-control text-field"
                    type="number"
                    [ngClass]="{
                                'is-invalid': providerForm.get('PhoneNumber')?.touched && providerForm.get('PhoneNumber')?.invalid,
                                'is-valid': providerForm.get('PhoneNumber')?.touched && providerForm.get('PhoneNumber')?.valid
                              }"
                    (paste)="$event.preventDefault()"
                    (drop)="$event.preventDefault()"
                    (contextmenu)="$event.preventDefault()"
                    (keydown)="blockInvalidKeys($event, 'number')"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    formControlName="PhoneNumber"
                    required
            >
          </div>
        </div>
        <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
              *ngIf="providerForm.get('PhoneNumber')?.touched && providerForm.get('PhoneNumber')?.invalid">
          Debe insertar un número telefónico
        </span>
      </div>
    </div>

    <div class="col-12 pt-3">
             <p style="font-size: 18px; font-weight: 600; text-transform: uppercase; text-align:center;"
          [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Contacto comercial</p>
    </div>

          <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre</label>
				<input
                type="text"
                formControlName="Contact"
                [ngClass]="{
                  'is-invalid': providerForm.get('Contact')?.touched && (providerForm.get('Contact')?.value === null || providerForm.get('Contact')?.value === ''),
                  'is-valid':providerForm.get('Contact')?.touched && (providerForm.get('Contact')?.value !== null || providerForm.get('Contact')?.value !== '')
                }"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockInvalidKeys($event, 'name')"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.Contact.touched && providerForm.controls.Contact.invalid && (!providerForm.controls.Contact.errors?.minlength || !providerForm.controls.Contact.errors?.maxlength)">
						Por favor inserte un nombre
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.Contact.errors?.minlength || providerForm.controls.Contact.errors?.maxlength">
						El nombre debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Apellido</label>
				<input
                type="text"
                formControlName="ContactLastName"
                [ngClass]="{
                  'is-invalid':providerForm.get('ContactLastName')?.touched && (providerForm.get('ContactLastName')?.value === null || providerForm.get('ContactLastName')?.value === ''),
                  'is-valid': providerForm.get('ContactLastName')?.touched && (providerForm.get('ContactLastName')?.value !== null || providerForm.get('ContactLastName')?.value !== '')
                }"
                class="form-control text-field"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockInvalidKeys($event, 'name')"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.ContactLastName.touched && providerForm.controls.ContactLastName.invalid && (!providerForm.controls.ContactLastName.errors?.minlength || !providerForm.controls.ContactLastName.errors?.maxlength)">
						Por favor inserte un apellido
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.ContactLastName.errors?.minlength || providerForm.controls.ContactLastName.errors?.maxlength">
						El apellido debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>


	    <div class="col-12 col-md-6 form-item pt-2">
			<div>
				<label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Email</label>
				<input class="form-control text-field"
                type="email"
                formControlName="EmailContact"
                [ngClass]="{
                  'is-invalid': providerForm.get('EmailContact')?.touched && (providerForm.get('EmailContact')?.errors && providerForm.get('EmailContact')?.errors?.errorEmailFormat || providerForm.get('EmailContact')?.value === null || providerForm.get('EmailContact')?.value === ''),
                  'is-valid': providerForm.get('EmailContact')?.touched && (providerForm.get('EmailContact')?.value !== null || providerForm.get('EmailContact')?.value !== '')
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockDangerousKeys($event)"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.EmailContact.touched && providerForm.controls.EmailContact.invalid && !providerForm.controls.EmailContact.errors?.pattern">
						Por favor inserte un email
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.EmailContact.errors?.pattern">
						Inserte un email valido
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nro. telefónico</label>
          <div class="d-flex">
            <div style="width: 100%">
              <select class="form-control text-field"
                      id="PhoneCodeContact"
                      [ngClass]="{
                        'is-invalid': providerForm.get('PhoneCodeContact')?.touched && (providerForm.get('PhoneCodeContact')?.value === null || providerForm.get('PhoneCodeContact')?.value === ''),
                        'is-valid': providerForm.get('PhoneCodeContact')?.touched && (providerForm.get('PhoneCodeContact')?.value !== null || providerForm.get('PhoneCodeContact')?.value !== '')
                      }"
                      formControlName="PhoneCodeContact"
              >
                <option value="" disabled>Seleccione código</option>
                <option *ngFor="let country of countries"
                        [value]="country.phone_code">
                          {{country.country_name}} (+{{country.phone_code}})
                </option>
              </select>
            </div>
            <div style="margin-left: 6px;">
              <input class=" form-control text-field"
                     type="number"
                       [ngClass]="{
                                  'is-invalid': providerForm.get('PhoneNumberContact')?.touched && providerForm.get('PhoneNumberContact')?.invalid,
                                  'is-valid': providerForm.get('PhoneNumberContact')?.touched && providerForm.get('PhoneNumberContact')?.valid
                                }"
                    (paste)="$event.preventDefault()"
                    (drop)="$event.preventDefault()"
                    (contextmenu)="$event.preventDefault()"
                    (keydown)="blockInvalidKeys($event, 'number')"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                     formControlName="PhoneNumberContact"
                     required>
            </div>
          </div>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.PhoneNumberContact.touched && providerForm.controls.PhoneNumberContact.invalid && !providerForm.controls.PhoneNumberContact.errors?.pattern">
              Debe insertar un número telefónico
            </span>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="providerForm.controls.PhoneNumberContact.errors?.pattern">
              Inserte un número de telefóno valido
            </span>
        </div>
	    </div>


    <div class="col-12 form-item pt-2 pb-5 mt-4">
          <div>
            <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">¿Algún comentario?</label>
            <textarea class="form-control text-field"
                      style="height:150px;"
                      formControlName="Comments"
                      [value]="providerForm.value.Comments"
                      (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      (keydown)="blockDangerousKeys($event)"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      ></textarea>
              <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf=" providerForm.controls.Comments.touched && providerForm.controls.Comments.invalid">
                Su comentario debe contener como máximo 200 carácteres
              </span>
          </div>
      </div>

    <!-- Razones Sociales (FormArray) -->
    <div class="col-12 pt-3">
      <p style="font-size: 16px; font-weight: 600; text-transform: uppercase; text-align:center;"
         [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">
        Razones Sociales
      </p>
    </div>

    <div formArrayName="legal_entities" class="col-12">
      <div *ngFor="let business of bussinessNames.controls; let i = index"
           [formGroupName]="i"
           class="business-name-group border p-3 mb-3 rounded"
           style="background-color: #f8f9fa;">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 style="font-weight: 600;">Razón Social #{{ i + 1 }}</h6>
          <button type="button" class="btn btn-danger btn-sm"
                  (click)="removeBusinessName(i)"
                  *ngIf="bussinessNames.length > 1">
            <i class="bi bi-trash"></i> Eliminar
          </button>
        </div>

        <div class="row">
          <!-- Nombre de la razón social -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre de la empresa</label>
            <input type="text" formControlName="name"
              [ngClass]="{
                'is-invalid': business.get('name')?.touched && business.get('name')?.invalid,
                'is-valid': business.get('name')?.touched && business.get('name')?.valid
              }"
               (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              [maxLength]="50"
              minLength="2"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              (input)="sanitizeInput($event)"
              (keydown)="blockDangerousKeys($event)"
              class="form-control text-field" required>
            <span class="booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('name')?.touched && business.get('name')?.invalid">
              Por favor inserte un nombre
            </span>
          </div>

          <!-- Documento -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">CUIT/CPF/RUT/RIF/NIT</label>
            <input type="text" formControlName="tax_document_number"
              [ngClass]="{
                'is-invalid': business.get('tax_document_number')?.touched && business.get('tax_document_number')?.invalid,
                'is-valid': business.get('tax_document_number')?.touched && business.get('tax_document_number')?.valid
              }"
               (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              [maxLength]="50"
              minLength="2"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              (input)="sanitizeInput($event)"
              (keydown)="blockDangerousKeys($event)"
              class="form-control text-field" required>
            <span class="booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('tax_document_number')?.touched && business.get('tax_document_number')?.invalid">
              Por favor inserte un CUIT/CPF/RUT/RIF/NIT
            </span>
          </div>

          <!-- Dirección de la razón social -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Dirección legal</label>
            <input type="text" formControlName="legal_address"
             (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              [maxLength]="50"
              minLength="2"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              (input)="sanitizeInput($event)"
              (keydown)="blockDangerousKeys($event)"
              [ngClass]="{
                'is-invalid': business.get('legal_address')?.touched && business.get('legal_address')?.invalid,
                'is-valid': business.get('legal_address')?.touched && business.get('legal_address')?.valid
              }"
              class="form-control text-field" required>
            <span class="booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('legal_address')?.touched && business.get('legal_address')?.invalid">
              Por favor inserte una dirección legal
            </span>
          </div>

          <!-- País -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">País</label>
            <select formControlName="country_id"
              (change)="getDestinations($event.target.value, i)"
              [ngClass]="{
                'is-invalid': business.get('country_id')?.touched && business.get('country_id')?.invalid,
                'is-valid': business.get('country_id')?.touched && business.get('country_id')?.valid
              }"
              class="form-control text-field" required>
              <option disabled value="">Selecciona un país</option>
              <option *ngFor="let co of countries" [value]="co.country_code">{{co.country_name}}</option>
            </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('country_id')?.touched && business.get('country_id')?.invalid">
              Por favor seleccione un país
            </span>
          </div>

          <!-- Estado -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Estado / Región</label>
            <select formControlName="state_id"
            (change)="getCities($event.target.value, i)"
              [ngClass]="{
                'is-invalid': business.get('state_id')?.touched && business.get('state_id')?.invalid,
                'is-valid': business.get('state_id')?.touched && business.get('state_id')?.valid
              }"
              class="form-control text-field" required>
              <option disabled [ngValue]="null">Selecciona una región</option>
              <option *ngFor="let state of getDestinationsForIndex(i)" [value]="state.destination_id">{{state.destination_name}}</option>
            </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('state_id')?.touched && business.get('state_id')?.invalid">
              Por favor seleccione una región
            </span>
          </div>

          <!-- Ciudad -->
          <div class="col-12 col-md-6 form-item mb-2">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Ciudad</label>
            <select formControlName="city_id"
              [ngClass]="{
                'is-invalid': business.get('city_id')?.touched && business.get('city_id')?.invalid,
                'is-valid': business.get('city_id')?.touched && business.get('city_id')?.valid
              }"
              (change)="selectedCity($event.target.value, i)"
              class="form-control text-field" required>
              <option disabled [ngValue]="null">Selecciona una ciudad</option>
              <option *ngFor="let city of getCitiesForIndex(i)" [value]="city.city_id">{{city.city_name}}</option>
            </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('city_id')?.touched && business.get('city_id')?.invalid">
              Por favor seleccione una ciudad
            </span>
          </div>

          <!-- Categorías -->
          <div class="col-12 col-md-12 form-item" style="text-transform:unset !important">
            <label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">CATEGORÍAS</label>
            <ng-select
              [items]="categories"
              bindLabel="name"
              bindValue="id"
              [multiple]="true"
              [closeOnSelect]="false"
              formControlName="category_ids"
              placeholder="Seleccione categorías"
              [ngClass]="{
                'is-invalid': business.get('category_ids')?.touched && business.get('category_ids')?.invalid,
                'is-valid': business.get('category_ids')?.touched && business.get('category_ids')?.valid
              }"
              class="form-control text-field"
              style="height: 38px; padding: 4px 8px;">
            </ng-select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important"
                  *ngIf="business.get('category_ids')?.touched && business.get('category_ids')?.invalid">
              Seleccione al menos una categoría
            </span>
          </div>
        </div>
      </div>

      <!-- Botón agregar razón social -->
      <div class="text-center mt-2 mb-3">
        <button type="button" class="btn"
        [ngStyle]="{'background-color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1, 'color': getClientsSettingAppAuth?.clients_setting_global?.color_main_2}"
                (click)="addBusinessName()">
          <i class="bi bi-plus-circle"></i> Agregar Razón Social
        </button>
      </div>
    </div>

  </div>

      <div class="row p-3 leyend rounded rounded-2">
	  	<div class="col-12 col-md-9 pt-3 pl-3">
			<p class="f-justify" class="font-parrafo-white pr-3">
				Completar todos los campos, nos permitirá gestionar mas rápido la configuración del usuario para acceder al sistema. Para ser parte de la suite tecnológica, debes ser un Operador Mayorista constituido legalmente en tu país con las habilitaciones correspondiente. Una vez aceptada la solicitud recibirás un mail con las indicaciones para acceder.
			</p>
		</div>
		<div class="col-12 col-md-12 form-item pt-3 d-flex justify-content-center" *ngIf="turnstileEnabled">
			<app-turnstile
				[siteKey]="turnstileSiteKey"
				action="joinus"
				[invisibleUntilSubmit]="true"
				(verified)="onTurnstileVerified($event)"
				(expired)="onTurnstileExpired()"
				(errored)="onTurnstileError()">
			</app-turnstile>
		</div>
		<div class="col-12 col-md-3 form-item pt-3 text-center">
			<input type="submit" class="btn-button s-l btn-leyend rounded-pill" value="ENVIAR" style="width: 90% !important;"/>
		</div>
	  </div>

</form>

<button *ngIf="!buttonError" class="border-0 bg-white" #openModalErrorJoinUs data-toggle="modal" data-target="#modalResError"></button>

<div class="modal fade center" id="modalResError" tabindex="-1" role="dialog" aria-hidden="true" style="top: 50%;">
  <div class="modal-dialog" role="document">
      <div class="d-flex justify-content-center bg-white modalResSignUp shadow" style="border: 1px solid rgb(204, 204, 204);">
        <div class="modal-header">
          <p style="font-family:'Poppins', sans-serif;font-weight: 600;padding: 14px; margin: 2px;">Este email ya fue registrado, por favor ingrese otro...</p>
          <button #closeButtonModalErrorSignup class="closeButtonModalErrorSignup" type="button" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
  </div>
</div>
